import React from 'react';

import LineItemsStep from '../LineItemsStep/LineItemsStep';
import ResultsStep from '../ResultsStep/ResultsStep';
import ReviewStep from '../ReviewStep/ReviewStep';
import TagUploadStep from '../TagUploadStep/TagUploadStep';
import { useUploadTagSheetContext } from '../UploadTagSheetStepperProvider/UploadTagSheetStepperProvider';

const UploadTagSheetStepper = (): React.JSX.Element => {
  const { step } = useUploadTagSheetContext();

  switch (step) {
    case 0:
      return <TagUploadStep />;
    case 1:
      return <LineItemsStep />;
    case 2:
      return <ReviewStep />;
    case 3:
      return <ResultsStep />;
    default:
      return <></>;
  }
};

export default UploadTagSheetStepper;
